require('./mortgageRequestDocumentationCenterView.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { MortgageRequestDocumentationCenter } = require('components/mortgageRequest/mortgageRequestDocumentationCenter/mortgageRequestDocumentationCenter');

class MortgageRequestDocumentationCenterView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestDocumentationCenter-breadcrumbText'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        const mortgageClassName = contactCenterClassName('mortgage-request-documentation-center-view__body', 'grid-view__body')
        return (
            <div className="mortgage-request-documentation-center-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestDocumentationCenter-titleHeader')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className={mortgageClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <MortgageRequestDocumentationCenter
                                    path={this.props.location.pathname}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestDocumentationCenterView.propTypes = {
    location: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
}

module.exports.MortgageRequestDocumentationCenterView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(withRouter(MortgageRequestDocumentationCenterView));
